import { computed, type MaybeRefOrGetter, toValue } from 'vue';

import type { User } from '@/shared/api';

import type { UserPresenceInfoSchemaType } from './schemas';
import { useUsersPresenceStore } from './stores';

const useUserPresence = (userId: MaybeRefOrGetter<User['id']>) => {
  const presenceStore = useUsersPresenceStore();

  const presenceData = computed<UserPresenceInfoSchemaType | null>(() =>
    presenceStore.getPresenseData(toValue(userId)),
  );

  return { presenceData };
};

export { useUserPresence };
